import React from "react";
import { Modal, Animated, StyleSheet, View } from "react-native";

import { colors, sizes } from "assets/constants";

type IConfirmAlert = {
  show: boolean;
  force?: boolean;
  hide: () => void;
  renderContent: (close: () => void) => JSX.Element;
};

export default function ConfirmAlert(props: IConfirmAlert) {
  const { show, hide, renderContent, force } = props;

  const animVar = React.useRef(new Animated.Value(0)).current;

  const startAnimate = React.useCallback(
    () =>
      Animated.spring(animVar, {
        toValue: 1,
        bounciness: 10,
        speed: 10,
        useNativeDriver: true,
      }).start(),
    [animVar]
  );

  const close = () => {
    animVar.setValue(0);
    hide();
  };

  const boxScale = animVar.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 1],
  });

  return (
    <Modal
      animationType="fade"
      onShow={startAnimate}
      visible={show}
      transparent
      onRequestClose={force ? undefined : close}
    >
      <View style={styles.container}>
        {renderContent && (
          <Animated.View
            style={{
              ...styles.box,
              transform: [{ scale: boxScale }],
            }}
          >
            {renderContent(close)}
          </Animated.View>
        )}
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#000000aa",
  },

  box: {
    width: "85%",
    maxWidth: 400,
    paddingHorizontal: sizes.space,
    paddingVertical: 2 * sizes.space,
    borderRadius: sizes.radius.md,
    backgroundColor: colors.white,
  },
});
